import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function InformantADHDScalesAdulthoodForm() {
    return (
        <PatientFormTemplate formTitle="Their Symptoms in Adulthood" />
    );
}